import React, { useState } from "react";
import Layout from "../components/Layout";
import ValidationSummary from "../components/validationSummary";
import TextInput from "../components/textInput";
import TextArea from "../components/textArea";

const Joi = require("@hapi/joi");

const schema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .label("Email")
    .required(),
  message: Joi.string().required(),
}).options({ stripUnknown: true });

function Contact(ctx) {
  const [contact, setContact] = useState({
    email: "",
    name: "",
    message: "",
  });
  const [validationErrors, setValidationErrors] = useState([]);

  const [submitted, setSubmitted] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  function handleChange(e) {
    let { value } = e.target;
    if (e.target.name === "email") {
      value = value.trim();
    }
    setContact({ ...contact, [e.target.name]: value });
  }

  async function sendEmail(e) {
    e.preventDefault();

    if (!submitted) {
      setSubmitted(true);
      const validationResult = schema.validate(contact);
      if (validationResult.error) {
        setValidationErrors(validationResult.error.details);
      } else {
        const res = await fetch(`/api/send-email`, {
          body: JSON.stringify(contact),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (res.status === 200) {
          setValidationErrors([]);
          setSubmitted(false);
          setMessageSent(true);
        } else {
          const errors = await res.json();
          setValidationErrors(errors.details);
        }
      }
    }

    setSubmitted(false);
  }

  return (
    <Layout
      brand={ctx.brand}
      showHeaderLinks={true}
      canonical="https://www.track-night.com/contact"
    >
      <div className="container">
        <div className="section">
          <h1 className="title">Get In Touch!</h1>
          <p>
            There are a number of questions we get asked a lot, so we made a{" "}
            <strong>
              <a href="/faq">Frequently Asked Questions</a>
            </strong>{" "}
            page.
          </p>
          <p>
            If you can&apos;t find an answer there, or you just want to say hi
            👋 fill in the form below and we&apos;ll get back to you as soon as
            we can!
          </p>
          <ValidationSummary validationErrors={validationErrors} />
          {messageSent ? (
            <div>
              <strong>Thanks for getting in touch!</strong> We&apos;ll get back
              to you soon.
            </div>
          ) : (
            <form onSubmit={sendEmail}>
              <div className="field">
                <label htmlFor="email" className="label">
                  Email
                </label>
                <div className="control">
                  <TextInput
                    validationErrors={validationErrors}
                    value={contact.email}
                    onChange={handleChange}
                    name="email"
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="name" className="label">
                  Name
                </label>
                <div className="control">
                  <TextInput
                    validationErrors={validationErrors}
                    value={contact.name}
                    onChange={handleChange}
                    name="name"
                  />
                </div>
              </div>
              <div className="field">
                <label htmlFor="message" className="label">
                  Message
                </label>
                <div className="control">
                  <TextArea
                    validationErrors={validationErrors}
                    value={contact.message}
                    onChange={handleChange}
                    name="message"
                  />
                </div>
              </div>
              <div className="field">
                <div className="control">
                  <button
                    id="send-message"
                    type="submit"
                    className="button is-medium is-success"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default Contact;
